import React from 'react';
import './NewQuestionContainer.scss';
import NewPrevQuestionPanel from './NewPrevQuestionPanel';
import NewCurrentQuestion from './NewCurrentQuestion';

const NewQuestionContainer = () => {
    return (
        <div className="question">
            <div className="questions__container">
                <NewPrevQuestionPanel />
                <NewCurrentQuestion />
            </div>
        </div>
    );
};

export default NewQuestionContainer;
